<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="748">
    <div class="px-12 pt-9 pb-7 white">
      <v-row class="pb-12">
        <v-col cols="12">
          <p
            class="primary--text font-weight-bold mb-2 modal-details-draft__title"
          >
            MINUTA RECUSADA!
          </p>
          <p class="primary--text font-weight-medium mb-8">
            A minuta foi recusada pelo aprovador. Veja o motivo:
          </p>
        </v-col>
        <v-col cols="12" class="modal-details-draft__content pa-2">
          <p class="primary--text mb-0">
            {{ item.minuta.comentario_recusa }}
          </p>
        </v-col>
        <v-col cols="12" class="pt-5">
          <v-row>
            <v-col
              cols="auto"
              v-for="(element, key) in item.minuta.anexos_recusa"
              :key="key"
              class="modal-details-draft__file px-4 py-2 mr-5 mb-5 mb-sm-0"
            >
              <div
                class="d-flex align-center gray--text body-2"
                @click="onPreviewFile(element)"
              >
                <v-icon class="pr-3" color="primary">
                  fa-file
                </v-icon>
                {{ element.nome }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="3">
          <BaseButton
            v-html="'OK'"
            class="secondary"
            width="100%"
            @click="closeModal"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  mixins: [DocumentsMixin],
  methods: {
    closeModal() {
      this.$emit("close");
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.modal-details-draft__
  &title
    font-size: 20px
  &content
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #FFFFFF
  &file
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FAFAFC
    cursor: pointer
    height: 42px
</style>
